import React from "react";
import {useAuthContext} from "../../contexts/AuthContext";
import {Navigate} from "react-router-dom";
import {urls} from "../../routes/urls";
import {isUndefined} from "lodash";
import {BounceLogo, Colors, Container, LoadingCenter} from "@bounce/shared/ui";
import {AuthPageContainer} from "../../ui/AuthPageContainer";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout = ({children}: AuthLayoutProps) => {
  const {isLoggedIn} = useAuthContext();

  if (isLoggedIn) {
    return <Navigate to={urls.home.url} />;
  }

  if (isUndefined(isLoggedIn)) {
    return (
      <Container
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoadingCenter />
      </Container>
    );
  }
  return (
    <AuthPageContainer sx={{justifyContent: "flex-start"}}>
      <Container sx={{width: "360px", gap: "32px"}}>
        <Container>
          <BounceLogo width={"150px"} height={"35px"} color={Colors.secondary._800} />
        </Container>
        {children}
      </Container>
    </AuthPageContainer>
  );
};
